// extracted by mini-css-extract-plugin
module.exports = {"graduationwork":"graduationwork_graduationwork__cif63"};